/**
 * Recusas de POST /orders.
 *
 * A API devolve `key` estável em toda recusa de lote, além de uma `message` em
 * inglês que não deve ser exibida ao comprador. Antes só `expired_batch` tinha
 * key e o resto vinha como texto — e como o front comparava por texto, nenhuma
 * das comparações casava com "Quantity not available": o comprador clicava em
 * "Finalizar compra" e a tela não dizia nada.
 *
 * O mapa por texto continua aqui de propósito: produção pode estar atrás do
 * sandbox, e uma tela muda é justamente o que não pode voltar a acontecer.
 */
export const ORDER_ERROR_MESSAGES = {
    quantity_not_available: 'Este lote não tem mais a quantidade que você escolheu.',
    insufficient_stock: 'O estoque acabou enquanto você finalizava a compra.',
    expired_batch: 'O período de venda deste lote terminou.',
    batch_not_active: 'Este lote não está disponível para venda.',
    batch_not_found: 'Este lote não existe mais.',
    batches_from_another_event: 'Há itens de outro evento no seu carrinho.',
    batches_from_another_establishment: 'Há itens de outro estabelecimento no seu carrinho.',
    batches_limit_exceeded: 'Você excedeu o limite de ingressos por compra.',
};

export const ORDER_ERROR_FALLBACK = 'Não foi possível concluir a compra. Tente novamente.';

/** Contrato anterior, quando a recusa vinha só como mensagem em inglês. */
const LEGACY_MESSAGES = {
    'Quantity not available': 'quantity_not_available',
    'Tickets not available': 'quantity_not_available',
    'Batches are from another event': 'batches_from_another_event',
};

/**
 * Recusas em que o estoque na tela ficou velho: além de avisar, vale recarregar
 * para o carrinho voltar a bater com o que existe.
 */
const STALE_STOCK_KEYS = [
    'quantity_not_available',
    'insufficient_stock',
    'expired_batch',
    'batch_not_active',
    'batch_not_found',
];

/**
 * Traduz a resposta de erro em algo exibível.
 *
 * `key` desconhecida cai no texto genérico em vez de passar batido — a lista de
 * keys pode crescer no servidor sem o front saber.
 */
export function resolveOrderError(response) {
    const data = response?.data;
    const key = data?.key || LEGACY_MESSAGES[data?.message];

    return {
        key,
        message: ORDER_ERROR_MESSAGES[key] || ORDER_ERROR_FALLBACK,
        shouldRefreshStock: STALE_STOCK_KEYS.includes(key),
    };
}
